//react
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Mobile, PC } from "../../media/MediaQuery";

//css
import styled from "styled-components";

// responsive
import { M, MMinus, T } from "../../utils/MT";

//component
import modalScroll from "../../utils/ModalScroll";
import BasicBtn from "../button/BasicBtn";

//img
// import CloseIcon from "../../../img/icon/icon_close.svg";

export default function DefaultModal({ closeModal, contents, goHome, Simple, text }) {
    //페이지 이동
    const navigate = useNavigate();
    const goMain = () => {
        navigate(`/`);
    };

    return (
        // <Container>
        <Container show={modalScroll.modalOpen()}>
            <Background
                onClick={() => {
                    closeModal(true);
                    modalScroll.modalClosed();
                }}
            ></Background>

            <ModalContents Simple={Simple}>
                {Simple ? (
                    <SmallModalWrap>
                        <Text>{text}</Text>
                        <BtnWrap
                            onClick={() => {
                                closeModal(true);
                                modalScroll.modalClosed();
                            }}
                        >
                            {goHome ? (
                                <BasicBtn
                                    text="홈으로"
                                    gray={true}
                                    black={true}
                                    onClick={() => {
                                        closeModal(true);
                                        modalScroll.modalClosed();
                                        goMain();
                                    }}
                                />
                            ) : (
                                <BasicBtn
                                    text="닫기"
                                    gray={true}
                                    black={true}
                                    onClick={() => {
                                        closeModal(true);
                                        modalScroll.modalClosed();
                                    }}
                                />
                            )}
                        </BtnWrap>
                    </SmallModalWrap>
                ) : (
                    contents()
                )}
            </ModalContents>
        </Container>
    );
}

const Container = styled.div`
    position: fixed;
    width: 100vw;
    height: 100vh;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;

    z-index: 99;
`;

const Background = styled.div`
    content: "";
    position: fixed;
    top: 0;
    left: 0;
    display: block;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
`;

const ModalContents = styled.div`
    display: flex;
    flex-direction: column;

    position: fixed;
    top: 50%;
    left: 50%;

    max-height: 90vh;
    padding: calc(100vw * (64 / 1920)) calc(100vw * (75 / 1920)) calc(100vw * (56 / 1920));
    border-radius: 10px;
    background-color: #ffffff;

    overflow: hidden;

    z-index: 100;

    transform: translate(-50%, -50%);

    ${({ Simple }) => {
        return (
            Simple &&
            `
        padding: calc(100vw * (35/ 1920)) calc(100vw * (10/ 1920)) calc(100vw * (40/ 1920)) ;
        `
        );
    }}

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (15 / 1300));
        padding: calc(100vw * (64 / 1300)) calc(100vw * (75 / 1300)) calc(100vw * (56 / 1300));

        ${({ Simple }) => {
            return (
                Simple &&
                `
                    padding: calc(100vw * (35/ 1300)) calc(100vw * (10/ 1300)) calc(100vw * (40/ 1300)) ;
                `
            );
        }}
    }

    @media screen and (max-width: 900px) {
        width: ${M(378)};
        max-height: 90vh;
        /* 왜 25야??? */
        /* border-radius: 25px; */
        /* padding: calc(100vw * (46/ 428)) calc(100vw * (18/ 428)) calc(100vw * (44/ 428)) ; */
        padding: ${M(46)} ${M(18)} ${M(44)};

        &::-webkit-scrollbar {
            display: none; /* Chrome, Safari, Opera*/
        }

        ${({ Simple }) => {
            return (
                Simple &&
                `
                padding: ${M(35)} ${M(10)} ${M(40)};
            `
            );
        }}
    }
`;

const SmallModalWrap = styled.div`
    width: calc(100vw * (400 / 1920));

    text-align: center;

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (400 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: ${M(378)};
    }
`;

const Text = styled.div`
    font-size: calc(100vw * (15 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (15 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(14)};
    }
`;

const BtnWrap = styled.div`
    width: calc(100vw * (100 / 1920));
    margin: 0 auto;

    margin-top: calc(100vw * (20 / 1920));

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (100 / 1300));

        margin-top: calc(100vw * (20 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: ${M(160)};

        margin-top: ${M(15)};

        & > p {
            padding: ${M(9)} 0;
        }
    }
`;
